var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexible-space-wrapper"},_vm._l((_vm.getActiveComponents(
            'CategoryPage',
            'B',
            _vm.dynamicComponents
        )),function(component){return _c(component.name,_vm._b({key:component.name,tag:"component"},'component',component.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }